import Hero from "../sections/Hero";
import Pillars from "../sections/Pillars";
import SolutionsTeaser from "../sections/SolutionsTeaser";
import CtaStrip from "../sections/CtaStrip";
import { COMPANY, ESTEEMED_CLIENTS } from "../data/content";

function getClientLogo(client) {
  const initials = client.name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="360" height="140" viewBox="0 0 360 140">
      <rect width="360" height="140" rx="24" fill="#020617" />
      <rect x="12" y="12" width="336" height="116" rx="18" fill="#0f172a" stroke="#22d3ee" stroke-width="2" />
      <circle cx="100" cy="70" r="28" fill="#22d3ee" opacity="0.18" />
      <text x="100" y="78" text-anchor="middle" font-family="Arial, sans-serif" font-size="26" font-weight="700" fill="#67e8f9">${initials}</text>
      <text x="190" y="64" text-anchor="middle" font-family="Arial, sans-serif" font-size="17" font-weight="600" fill="#f8fafc">${client.name}</text>
      <text x="190" y="88" text-anchor="middle" font-family="Arial, sans-serif" font-size="10" letter-spacing="4" fill="#64748b">CLIENT</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-slate-950 text-slate-100 min-h-screen">
      <Hero />
      
      <Pillars />
      
      <SolutionsTeaser />
      {/* Esteemed Clients */}
      <section className="py-20 md:py-28 px-6 md:px-10 border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-12 gap-10 mb-10">
            <div className="lg:col-span-7">
              <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono mb-4">
                / Esteemed Clients
              </div>
              <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-slate-50">
                Trusted across enterprise,
                <br />
                <span className="text-slate-500">healthcare & government.</span>
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/5 border border-white/5" data-testid="clients-grid">
            {ESTEEMED_CLIENTS.map((client) => (
              <div key={client.name} className="flex items-center justify-center bg-slate-950 px-5 py-6 hover:bg-slate-900 transition-colors group">
                <img
                  src={client.logo || getClientLogo(client)}
                  alt={client.name}
                  className="h-16 w-full max-w-[180px] object-contain"
                />
              </div>
            ))}
          </div>

          <div className="mt-6 text-xs uppercase tracking-[0.25em] text-slate-600 font-mono">
            + {COMPANY.gem}
          </div>
        </div>
      </section>
      <CtaStrip />
    </main>
  );
}
